const style = (theme) => {
  const output = {
    root: {
      minHeight: '100%',
      background: theme.colors[3],
      color: theme.colors[2],
    },
    wrapper: {
      extend: theme.wrapper,
      display: 'flex',
      paddingTop: 200,
    },

  }

  return output
}

export default style
